import { createListenerMiddleware, Dispatch, ListenerEffectAPI, PayloadAction } from '@reduxjs/toolkit'
import { userActions } from '../slices/userSlice'
import { appActions } from '../slices/appSlice'
import { IdTokenData } from '@/features/auth/types/idTokenSchema'

const userDataMiddleware = createListenerMiddleware()

const effect = (action: PayloadAction<IdTokenData>, listenerApi: ListenerEffectAPI<unknown, Dispatch>) => {
  const userId = action.payload.sub

  if (userId) {
    const settingsJson = localStorage.getItem(`user-${userId}`)

    if (settingsJson) {
      try {
        const { isUtc, isDarkMode, isChartOpen } = JSON.parse(settingsJson)

        listenerApi.dispatch(appActions.setUtc(isUtc))
        listenerApi.dispatch(appActions.setDarkMode(isDarkMode))
        listenerApi.dispatch(appActions.setChartClosed(isChartOpen))
      } catch (error) {
        console.error('Failed to parse settings from localStorage', error)
      }
    }
  }
}

userDataMiddleware.startListening({ actionCreator: userActions.setData, effect })

export default userDataMiddleware
